import React from 'react'
import ReactSlider from 'react-slider'
import './Slider.css' // Lisää tyylit

const RangeSlider = ({
  name,
  value,
  onChange,
  min = 0,
  max = 20,
  step = 1,
}) => {
  return (
    <td>
      <div className="slider-container">
        <label>
          {name}: {value[0]} - {value[1]}
        </label>
        <ReactSlider
          className="horizontal-slider"
          thumbClassName="example-thumb"
          trackClassName="example-track"
          defaultValue={value}
          min={min}
          max={max}
          step={step}
          onChange={onChange}
          renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
        />
      </div>
    </td>
  )
}

export default RangeSlider
